import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    list: [],
    details: [],
    groupOfItemsDetails:[]
  },
  getters: {
    list: (state) => state.list,
    details: (state) => state.details,
    groupOfItemsDetails: (state) => state.groupOfItemsDetails
  },
  actions: {
    create({ commit, dispatch }, model) {
      return ajax.post('ProductManagement/api/ConfigurableProducts', model).then(r => {
      })
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete('ProductManagement/api/ConfigurableProducts', { data: { "configurableProductId": id } }, { headers: { 'Content-Type': 'application/json' } }).then(r => {
      })
    },
    update({ commit, dispatch }, model) {
      return ajax.put('ProductManagement/api/ConfigurableProducts', model)
    },
    fetchSingle({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax.get('ProductManagement/api/ConfigurableProductsQuery/' + id).then(r => {
          commit('setDetails', r.data);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
    assignItemInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax.post('ProductManagement/api/ConfigurableProducts/items', model).then(r => {
          resolve(r.data);
        }).catch(e => {
          reject(e.response.data);
        });
      })
    },
    fetchGroupOfItems({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax.get('/ProductManagement/api/ConfigurableProductsQuery/' + id + '/group-of-items').then(r => {
          commit('setGroupOfItemsDetails', r.data);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setGroupOfItemsDetails(state, data) {
      state.groupOfItemsDetails = data;
    }
  }
}
